import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { buildSeoBrandString } from 'helpers/SeoUrlBuilder';
import css from 'styles/components/landing/melodyBrandIndex.scss';

const MelodyBrandIndex = ({ slotName, slotDetails, onLandingComponentClick }, { testId, marketplace }) => {
  const { landing: { melodyBrandIndex: { useSearchSlashUrls } = {} } } = marketplace;
  const { brands, monetateId } = slotDetails;

  const makeBrandLink = ({ id, name }) => (
    <li key={id}>
      <Link
        to={useSearchSlashUrls ? `/search/null/filter/brandNameFacet/${encodeURIComponent(name)}` : buildSeoBrandString(name, id)}
        data-eventlabel="melodyBrandIndex"
        data-eventvalue={`brandId-${id}-name-${name}`}
        onClick={onLandingComponentClick}
        data-test-id={testId('melodyBrandIndexBrandname')}>
        {name}
      </Link>
    </li>
  );

  return (
    <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
      <h2>{brands.length} Total</h2>
      <ul>
        {brands.map(brand => makeBrandLink(brand))}
      </ul>
    </div>
  );
};

MelodyBrandIndex.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object.isRequired
};

export default MelodyBrandIndex;
